import { filter } from 'lodash';
import { useState, useEffect } from 'react';
import { Switch } from '@mui/material';

// redux
import { useDispatch, useSelector } from 'src/redux/store';
import { getListaUsuariosByClienteId } from 'src/redux/slices/user';

// actions
import actionEditarPerfil from 'src/actions/usuarios/actionEditarPerfil';

// hooks
import ModalEditarAgente from '../../cadastro/ModalEditarAgente';
import ModalEditarSenhaAgente from '../../cadastro/ModalEditarSenhaAgente';
import { Avatar, AvatarImage, AvatarFallback } from 'src/@/components/ui/avatar';
import { USUARIOS_COMPONENT_DESIGN as D } from './UsuariosComponent.design';
import Iconify from 'src/components/Iconify';

// utils
import { fDateTime } from 'src/utils/formatTime';

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    if (query) {
        return filter(array, (_user) => _user.nomeFantasia.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }
    return stabilizedThis.map((el) => el[0]);
}

export default function UsuariosComponent({ user }) {
    const dispatch = useDispatch();
    const { usuariosList } = useSelector((state) => state.user);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('nome');
    const [filterName, setFilterName] = useState('');
    const [openEditarSenha, setOpenEditarSenha] = useState(false);
    const [openEditarPerfil, setOpenEditarPerfil] = useState(false);
    const [senha, setSenha] = useState('');
    const [confirmarSenha, setConfirmarSenha] = useState('');
    const [usuarioId, setUsuarioId] = useState('');
    const [dataUsuario, setDataUsuario] = useState(null)

    useEffect(() => {
        dispatch(getListaUsuariosByClienteId(user.clienteId, '1'));
    }, []);

    const handleOpenDialogEditarPerfil = (usuario) => {
        setDataUsuario(usuario);
        setOpenEditarPerfil(true)
    }

    const handleOpenDialogEditarSenha = (data) => {
        setDataUsuario(data)
        setOpenEditarSenha(true)
    }

    const resetarCampos = () => {
        setUsuarioId('');
        setSenha('');
        setConfirmarSenha('');
    }

    async function handleEditStatus(usuarioId, status) {
        try {
            await actionEditarPerfil({
                usuarioId: usuarioId,
                status: status,
            });
            dispatch(getListaUsuariosByClienteId(user.clienteId, '1'));
        } catch (error) {
            console.log('error', error);
        }
    }

    const filteredUsers = applySortFilter(usuariosList, getComparator(order, orderBy), filterName);

    return (
        <div className={D.root} style={{ fontFamily: D.fontStack }}>
            <div className={D.stickyHeader}>
                <div className={D.container}>
                    <div className={D.topbar}>
                        <div className={D.topbarIdentity}>
                            <div className="min-w-0">
                                <h1 className={D.title}>Usuários</h1>
                                <p className={D.subtitle}>
                                    Agentes da empresa. Edite perfil, senha e quem está ativo no atendimento.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ModalEditarSenhaAgente
                open={openEditarSenha}
                dataUsuario={dataUsuario}
                onCallback={() => setOpenEditarSenha(false)}
                onClose={() => setOpenEditarSenha(false)}
                callbackEdit={() => {
                    setOpenEditarSenha(false);
                    resetarCampos();
                }}
            />

            <ModalEditarAgente
                user={user}
                open={openEditarPerfil}
                onClose={() => setOpenEditarPerfil(false)}
                dataUsuario={dataUsuario}
                callbackEdit={() => {
                    setOpenEditarPerfil(false);
                    setDataUsuario(null);
                    dispatch(getListaUsuariosByClienteId(user.clienteId));
                }}
            />

            <div className={`${D.container} pt-6 ${D.pageBody}`}>
                <div className={D.stack}>
                    <div className={D.sectionHeader}>
                        <div className={D.sectionHeaderMain}>
                            <h2 className={D.sectionHeaderTitle}>Equipe</h2>
                            <p className={D.sectionHeaderSub}>
                                Desligar o status tira a pessoa da fila de atendimento.
                            </p>
                        </div>
                    </div>

                    <div className={D.cardFlush}>
                        {filteredUsers.length === 0 ? (
                            <div className={D.emptyWrap}>
                                <div className={D.emptyIcon}>
                                    <Iconify icon="eva:people-outline" width={28} />
                                </div>
                                <p className={D.emptyTitle}>Nenhum usuário encontrado</p>
                                <p className={D.emptyDesc}>
                                    Não há usuários cadastrados ou correspondentes à busca.
                                </p>
                            </div>
                        ) : (
                            <div className={D.tableWrap}>
                                <div className={D.tableHeadRow}>
                                    <div className={`flex-1 min-w-[200px] pr-4 ${D.tableHead}`}>Nome</div>
                                    <div className={`w-32 hidden md:block ${D.tableHead}`}>Setor</div>
                                    <div className={`w-20 hidden md:block ${D.tableHead}`}>Ramal</div>
                                    <div className={`w-48 hidden lg:block ${D.tableHead}`}>Email</div>
                                    <div className={`w-24 text-center ${D.tableHead}`}>Intervalo</div>
                                    <div className={`w-32 text-right hidden xl:block ${D.tableHead}`}>Última ativ.</div>
                                    <div className={`w-24 text-center ${D.tableHead}`}>Status</div>
                                    <div className={`w-24 text-right ${D.tableHead}`}>Ações</div>
                                </div>
                                {filteredUsers.map((row) => (
                                    <div key={row._id} className={D.tableRow}>
                                        <div className="flex-1 min-w-[200px] pr-4">
                                            <div className="flex items-center gap-3 min-w-0">
                                                <Avatar className="h-9 w-9 rounded-[10px]">
                                                    <AvatarImage src={row.avatar} alt={row.nomeFantasia} />
                                                    <AvatarFallback className="bg-[#ede9fe] text-[#5b21b6] text-[13px] font-semibold rounded-[10px]">
                                                        {(row.nomeFantasia || '?').charAt(0).toUpperCase()}
                                                    </AvatarFallback>
                                                </Avatar>
                                                <div className="min-w-0">
                                                    <p className={`${D.tableCell} font-semibold truncate`}>{row.nomeFantasia}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`w-32 hidden md:block ${D.tableCellMuted} truncate`}>
                                            {row.nome_setor || '—'}
                                        </div>
                                        <div className={`w-20 hidden md:block ${D.tableCellMuted}`}>
                                            {row.ramal || '—'}
                                        </div>
                                        <div className={`w-48 hidden lg:block pr-2 ${D.tableCellMuted} truncate`} title={row.email}>
                                            {row.email}
                                        </div>
                                        <div className="w-24 flex justify-center">
                                            <span className={`${D.badge} ${row.userStandby ? D.badgeOk : D.badgeNeutral}`}>
                                                {row.userStandby ? 'Sim' : 'Não'}
                                            </span>
                                        </div>
                                        <div className={`w-32 text-right hidden xl:block ${D.tableCellMuted}`}>
                                            {fDateTime(row.lastOnline)}
                                        </div>
                                        <div className="w-24 flex justify-center">
                                            <Switch
                                                checked={row.status}
                                                onChange={(e) => handleEditStatus(row._id, e.target.checked)}
                                                color="primary"
                                                size="small"
                                                sx={{
                                                    '& .MuiSwitch-switchBase.Mui-checked': { color: '#6d28d9' },
                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#6d28d9' },
                                                    '& .MuiSwitch-track': { backgroundColor: '#d4d4d8' },
                                                }}
                                            />
                                        </div>
                                        <div className="w-24 flex justify-end gap-1.5">
                                            <button
                                                type="button"
                                                title="Alterar senha"
                                                onClick={() => handleOpenDialogEditarSenha(row)}
                                                className={D.iconButton}
                                            >
                                                <Iconify icon="eva:lock-outline" width={16} />
                                            </button>
                                            <button
                                                type="button"
                                                title="Editar usuário"
                                                onClick={() => handleOpenDialogEditarPerfil(row)}
                                                className={D.iconButton}
                                            >
                                                <Iconify icon="eva:edit-2-outline" width={16} />
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
